export default "__VITE_ASSET__Cck9aF8O__"